import { makeStyles, createStyles } from '@material-ui/core/styles';

import sunIcon from '@/assets/svg/icons/sun.svg';
import bDayIcon from '@/assets/svg/icons/birthday.svg';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '200px',
      paddingTop: '6px',
      '& :not(:last-child)': {
        marginBottom: 12.5,
        borderBottom: '1px solid #EDF2F7',
      },
    },
    iconBlock: {
      display: 'flex',
      '& :not(:last-child)': {
        marginBottom: 0,
      },
    },
    icon: {
      marginTop: '12px',
      minHeight: '16px',
      minWidth: '16px',
      width: '16px',
      height: '16px',
      marginRight: '6px',
    },
    itemText: {
      fontSize: '11px',
      lineHeight: '15.29px',
      letterSpacing: '0.16px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textDecoration: 'none',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    notVacation: {
      height: '20.5px',
      paddingBottom: '8px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    sun: {
      backgroundImage: `url(${sunIcon})`,
    },
    bDay: {
      backgroundImage: `url(${bDayIcon})`,
    },
    eventIcon: {
      width: '20px',
      height: '20px',
      marginLeft: '15px',
      marginBottom: 0,
      cursor: 'pointer',
    },
    vacation: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      '& :first-child': {
        borderBottom: '0px',
      },
    },
  }),
);

export default useStyles;
